export default {
	"fca1": "เปิดบัญชี FCA",
	"fca1-m": "เปิดบัญชี FCA",
	"fca2": "EBC Financial Group (UK) Ltd ที่ก่อตั้งขึ้นในประเทศอังกฤษ ได้รับการอนุญาตและควบคุมโดย Financial Conduct Authority หมายเลขอ้างอิง: 927552",
	"fca3": "ตามกฎของ Financial Conduct Authority (FCA) ที่เกี่ยวกับการจัดประเภทลูกค้า เราต้องจัดประเภทลูกค้าของเราเป็นลูกค้ามืออาชีพ ลูกค้ารายย่อย หรือคู่สัญญาที่มีคุณสมบัติที่เหมาะสม<br><br>ตามที่ บริษัท FCA อนุญาตให้ EBC Financial Group (UK) Ltd ให้บริการเฉพาะลูกค้ามืออาชีพหรือคู่สัญญาที่ได้รับสิทธิ์ที่เหมาะสม ดังนั้นถ้าคุณมีคุณสมบัติประเภทใดประเภทหนึ่งเหล่านี้ คุณอาจสามารถเปิดบัญชีด้วยเลเวอเรจ 100x และเงินของคุณจะถูกเก็บไว้ในบัญชี EBC Financial Group (UK) Ltd กับ Barclays Bank PLC",
    "fca4":{
		"title":"นักลงทุนมืออาชีพต้องมีคุณสมบัติตรงตามข้อกําหนดสองข้อต่อไปนี้:",
		"title-m":"นักลงทุนมืออาชีพต้องมีคุณสมบัติตรงตามข้อกําหนดสองข้อต่อไปนี้:",
		"desc":"ลูกค้าได้ดําเนินการอย่างมีนัยสําคัญในตลาดที่เกี่ยวข้องเฉลี่ย 10 รายการขึ้นไปต่อไตรมาสในปีที่ผ่านมา",
		"desc1":"ถือพอร์ตการลงทุนที่มีมูลค่ามากกว่าครึ่งล้านยูโร รวมไปถึงการฝากเงินสดและเครื่องมือทางการเงิน",
		"desc2":"มีประสบการณ์การทํางานในอุตสาหกรรมการเงินอย่างน้อย 1 ปี และมีความรู้ด้านการซื้อขาย CFD/อนุพันธ์เป็นอย่างดี"
	},
	"fca5":{
		"title":"ขั้นตอนการเปิดบัญชี FCA",
		"desc":"ดาวน์โหลดและกรอกแบบฟอร์มใบสมัคร",
		"desc1":"จัดเตรียมและลงชื่อรับรองเอกสาร",
		"desc2":"ส่งเอกสารและสมัครทางอีเมลที่ EBC Financial Group (UK) Ltd",
		"desc3":"การประเมินการปฏิบัติตามข้อกําหนดใบสมัครและเอกสารสําหรับการลงนามจะถูกส่งหากผู้สมัครมีคุณสมบัติเหมาะสม",
		"desc4":"เมื่อลงชื่อเสร็จสมบูรณ์ บัญชีจะได้รับการอนุมัติ",
		"btn":"application form for professional clients",
		"btn1":"แบบฟอร์มใบสมัครสําหรับลูกค้ามืออาชีพ"
	},
	"fca6":{
		"title":"เปิดบัญชีที่ได้รับการดูแลโดย FCA กับ EBC Financial Group (UK) Ltd และได้รับความสะดวกสบายจากกฎระเบียบชั้นนําและความปลอดภัยของกองทุน",
		"title-m":"เปิดบัญชีที่ได้รับการดูแลโดย FCA กับ EBC Financial Group (UK) Ltd และได้รับความสะดวกสบายจากกฎระเบียบชั้นนําและความปลอดภัยของกองทุน",
		"desc":"หน่วยงานกํากับดูแลทางการเงิน (FCA)",
		"desc1":"อีเมลล์: ",
		"desc2":""
	},
	"lang":"en",
	FCA流动性清算账户开设流程: `ขั้นตอนการเปิดบัญชี FCA`,
	"EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商":
	  `EBC Financial Group Limited ได้รับการรับรองจาก Financial Conduct Authority (FCA) ให้บริการด้านการลงทุนอย่างถูกต้อง โดยมีใบอนุญาตให้ดำเนินการในฐานะโบรกเกอร์ โดยคําสั่งซื้อของลูกค้าทั้งหมดจะถูกส่งต่อไปยังผู้ให้บริการสภาพคล่องของเราโดยตรง ซึ่งไม่มีการแทรกแซงจากคนกลาง<br/>
หมายเลขใบอนุญาต: 927552FCA`,
	"在EBC Financial Group Limited开设FCA流动性清算账户":
	  "ลูกค้าที่เปิดบัญชีกับ EBC Financial Group Limited มีสิทธิ์เรียกร้องค่าชดเชยสูงถึง 85,000 ปอนด์ ภายใต้เงื่อนไขของ FSCS",
	"欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID": `ตามกฎของ Financial Conduct Authority (FCA) ที่เกี่ยวกับการจัดประเภทลูกค้า ส่งผลให้เราจัดการแยกประเภทลูกค้า เช่นลูกค้ามืออาชีพ ลูกค้ารายย่อย หรือคู่สัญญาที่มีคุณสมบัติที่เหมาะสม เป็นต้น`,
	根据FCA法规: `ตามที่หน่วยงาน FCA อนุญาตให้ EBC Financial Group Limited ให้บริการเฉพาะลูกค้ามืออาชีพหรือคู่สัญญาที่ได้รับสิทธิ์ที่เหมาะสม ดังนั้นถ้าคุณมีคุณสมบัติตรงตามประเภทที่กำหนด คุณจะสามารถเปิดบัญชีด้วยเลเวอเรจ 100 เท่า และเงินทุนของคุณจะถูกเก็บไว้ในบัญชี EBC Financial Group Ltd กับ Barclays Bank PLC`,
	专业投资者须满足以下三个标准中的其中两个: `นักลงทุนมืออาชีพต้องมีคุณสมบัติตรงตามเกณฑ์ 2 ใน 3 ข้อต่อไปนี้:`,
	"过去一年平均交易频率达到10次/季度": "มีประสบการณ์การซื้อขายในตลาดที่เกี่ยวข้องโดยเฉลี่ย 10 รายการขึ้นไปต่อไตรมาสในปีที่ผ่านมา",
	持有超过50万欧元的投资组合:
	  "ถือพอร์ตการลงทุนที่มีมูลค่ามากกว่า 500,000 ยูโร รวมไปถึงเงินฝากและตราสารทางการเงิน",
	在金融行业工作或至少工作过一年:
	  "มีประสบการณ์การทํางานในอุตสาหกรรมการเงินขั้นต่ำ 1 ปี และมีความรู้ด้านการซื้อขาย CFD หรืออนุพันธ์เป็นอย่างดี",
	FCA流动性清算账户开户流程: `ขั้นตอนการเปิดบัญชี FCA`,
	获取申请表: "ดาวน์โหลดแบบฟอร์มใบสมัคร",
	访EBC英国站: "รับแบบฟอร์มการสมัครบนเว็บไซต์ EBC UK",
	提交材料: "ยื่นเอกสาร",
	按要求填写: "กรอกข้อมูลและอัปโหลดเอกสารการสมัคร",
	合规审核: "ตรวจสอบความถูกต้อง",
	等待合规审核: "ลงนามในเอกสารและรอการตรวจสอบ",
	开户成功: "เปิดบัญชีสำเร็จ",
	登录并设置您的FCA账户: "เข้าสู่ระบบ และตั้งค่าบัญชี FCA",
	最权威的监管保护和最安全的: `เปิดบัญชีกับ EBC Financial Group (UK) Ltd ที่อยู่ภายใต้การกำกับดูแลของ FCA เพื่อความมั่นใจในกฎระเบียบที่ได้มาตรฐานและความปลอดภัยของเงินทุน
`,
	"英国金融市场行为管理局（FCA）": "หน่วยงานกํากับดูแลทางการเงิน (FCA)",
	FCA流动性清算账户咨询邮箱: `อีเมล: 
					  <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>`,
}

